var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardReaderAccessSystem01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.06,14.04H2.94V3.92h10.13V14.04z M3.44,13.54h9.13V4.42H3.44V13.54z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.75,
    y: 1.27,
    className: "st2",
    width: 0.5,
    height: 2.91
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.87,9.43l0.45,0.11C7.23,9.92,7.06,10.2,6.81,10.4c-0.25,0.2-0.55,0.29-0.91,0.29 c-0.37,0-0.67-0.08-0.9-0.23S4.6,10.1,4.48,9.81C4.36,9.53,4.3,9.22,4.3,8.9c0-0.36,0.07-0.67,0.2-0.93 C4.64,7.7,4.83,7.5,5.08,7.36c0.25-0.14,0.53-0.21,0.83-0.21c0.34,0,0.63,0.09,0.86,0.26c0.23,0.17,0.4,0.42,0.49,0.74l-0.45,0.1 C6.74,8,6.63,7.82,6.48,7.71C6.32,7.6,6.13,7.54,5.9,7.54c-0.26,0-0.48,0.06-0.66,0.19c-0.18,0.13-0.3,0.3-0.37,0.51 C4.8,8.45,4.77,8.67,4.77,8.89c0,0.29,0.04,0.55,0.13,0.76c0.08,0.22,0.22,0.38,0.4,0.49c0.18,0.11,0.37,0.16,0.58,0.16 c0.25,0,0.47-0.07,0.64-0.22S6.81,9.72,6.87,9.43z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.35,10.63V7.21h1.52c0.3,0,0.54,0.03,0.7,0.09s0.29,0.17,0.38,0.33s0.14,0.33,0.14,0.52 c0,0.24-0.08,0.45-0.24,0.61c-0.16,0.17-0.4,0.27-0.73,0.32c0.12,0.06,0.21,0.11,0.27,0.17c0.13,0.12,0.26,0.27,0.38,0.46 l0.6,0.93h-0.57l-0.45-0.71c-0.13-0.21-0.24-0.36-0.33-0.47S9.85,9.26,9.78,9.22C9.72,9.18,9.65,9.15,9.58,9.13 C9.53,9.12,9.44,9.11,9.32,9.11H8.8v1.52H8.35z M8.8,8.72h0.97c0.21,0,0.37-0.02,0.49-0.06c0.12-0.04,0.21-0.11,0.27-0.21 c0.06-0.09,0.09-0.2,0.09-0.31c0-0.16-0.06-0.29-0.18-0.4c-0.12-0.1-0.3-0.16-0.56-0.16H8.8V8.72z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardReaderAccessSystem01);
export default __webpack_public_path__ + "static/media/CardReaderAccessSystem-01.64595c28aeb94691fe104f8114f7bbbd.svg";
export { ForwardRef as ReactComponent };